var render = function () {
  var _vm$blockchain;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail",
    attrs: {
      "chain": (_vm$blockchain = _vm.blockchain) === null || _vm$blockchain === void 0 ? void 0 : _vm$blockchain.name
    }
  }, [_vm.loading && !_vm.subnetsLoaded ? _c('Loader', {
    attrs: {
      "content-id": _vm.id,
      "message": 'Fetching Blockchain Details'
    }
  }) : [_c('BlockchainSummary', {
    attrs: {
      "blockchain": _vm.blockchain
    }
  }), _vm.blockchain ? [_vm.currentSubnet !== null ? _c('div', {
    staticClass: "action"
  }, [_c('section', {
    staticClass: "bottom_info"
  }, [_c('RecentBlocks', {
    staticClass: "card"
  }), _c('div', {
    staticClass: "transactions"
  }, [_c('RecentTransactions', {
    staticClass: "card recent_tx"
  })], 1)], 1)]) : _vm._e(), _vm.blockchain.indexed ? _c('div', {
    staticClass: "card blockchain_tx"
  }, [_c('TxHeader'), _c('TxInteractive', {
    attrs: {
      "transactions": _vm.transactions,
      "assets-loaded": _vm.assetsLoaded,
      "loading": _vm.loading,
      "chains": _vm.chain,
      "blockchain": _vm.blockchain,
      "has-more": _vm.hasMore
    },
    on: {
      "more": _vm.more,
      "change": _vm.fetchTx
    }
  })], 1) : _vm._e()] : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }